import React from 'react'


const Footer = () => {
  return (
    <div className='footer'>
       <p>Copyright @ 2024, CryptoPort- All Right Reserved</p>
    </div>
  )
}

export default Footer
